import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import PasswordResetPage from '../../components/auth/password-reset-page';
import { withTranslation } from '../../lib/i18n';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';

class PasswordReset extends React.Component {
  static async getInitialProps() {
    return {
      namespacesRequired: ['common'],
      pageType: 'auth.password_reset',
    };
  }

  render() {
    const { club, t } = this.props;
    return (
      <>
        <Head>
          <title>{t('common:password_reset_title')}</title>
        </Head>
        <PasswordResetPage club={club} />
      </>
    );
  }
}

PasswordReset.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation(['common'])(PasswordReset);
